import { CurrentDiscountDto } from "./currentDiscountDto";
import { DescriptionTraductionDto } from "./descriptionTraductionDto";
import { OptionalAdministrativeFeeDto } from "./optionalAdministrativeFeeDto";
import { ProductsOrSubjectsOfRegistrationDto } from "./productsOrSubjectsOfRegistrationDto";

export class EnrollmentFeeDiscountsResponse {

    currencyCode!: string;

    listCurrencyTraduction: DescriptionTraductionDto [] = [];

    listProductsOrSubjectsOfRegistration: ProductsOrSubjectsOfRegistrationDto [] = [];

    listOptionalAdministrativeFee: OptionalAdministrativeFeeDto [] = [];

    listCurrentDiscount: CurrentDiscountDto [] = [];


}